module.exports = __webpack_public_path__ + "public/images/about-exhibition/image2.ab420dc07c3fed0d53a50ac8e803ad83.jpg";